import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { ButtonExpansion } from './ButtonExpansion';

type ButtonExpansionProps = React.ComponentProps<typeof ButtonExpansion>;
type ButtonExpansionLessProps = Omit<ButtonExpansionProps, 'children'>;

export const ButtonExpansionLess = (props: ButtonExpansionLessProps) => (
    <ButtonExpansion {...props}>
        {translate('seller_page_perseus.professions_page.main_content.show_less')}
    </ButtonExpansion>
);
